var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.25,
    stroke: "#2B323B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 20.6818C19.7626 20.9747 20.2374 20.9747 20.5303 20.6818C20.8232 20.3889 20.8232 19.9141 20.5303 19.6212L19.4697 20.6818ZM14.4697 15.6818L19.4697 20.6818L20.5303 19.6212L15.5303 14.6212L14.4697 15.6818Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.0c6c070f1cf6f2c6fc6e9c0fcc06d049.svg";
export { ForwardRef as ReactComponent };